import axios from "axios";

export const createBusinessPlanAndPitchDeck = (submissions, success, failure) => {
    const url = `/api/v1/magic/businessPlanAndPitchDeck`;

    axios.post(url, {
        submissions: submissions,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};
